export enum Permission {
  OFFICIAL_ACCOUNT_READ = 'official_account.read',
  OFFICIAL_ACCOUNT_ACCESS = 'official_account.access',

  // Official account management
  OFFICIAL_ACCOUNT_CREATE = 'official_account.create',
  OFFICIAL_ACCOUNT_UPDATE = 'official_account.update',
  OFFICIAL_ACCOUNT_DELETE = 'official_account.delete',

  // Admin management
  ADMIN_MANAGEMENT_CREATE = 'admin_management.create',
  ADMIN_MANAGEMENT_READ = 'admin_management.read',
  ADMIN_MANAGEMENT_UPDATE = 'admin_management.update',
  ADMIN_MANAGEMENT_DELETE = 'admin_management.delete',

  // Delivery management
  DELIVERY_MANAGEMENT_CREATE = 'delivery_management.create',
  DELIVERY_MANAGEMENT_READ = 'delivery_management.read',

  DELIVERY_MANAGEMENT_TEST_PUSH = 'delivery_management.test_push',
  DELIVERY_MANAGEMENT_ACTUAL_PUSH = 'delivery_management.actual_push',

  DELIVERY_MANAGEMENT_DELETE = 'delivery_management.delete',
  DELIVERY_MANAGEMENT_DOWNLOAD = 'delivery_management.download',

  DELIVERY_MANAGEMENT_CANCEL_SCHEDULED_MESSAGE = 'delivery_management.cancel_scheduled_message',

  // Friends management
  FRIENDS_MANAGEMENT_READ = 'friends_management.read',
  FRIENDS_MANAGEMENT_DELIVERY_INDIVIDUAL_MESSAGE = 'friends_management.delivery_individual_message',

  CAMPAIGN_READ = 'campaign.read',
  CAMPAIGN_UPDATE = 'campaign.update',
}

export enum AssignPermission {
  OFFICIAL_MANAGE = 'official_account.manage',
  DELIVERY_MANAGEMENT_ACTUAL_PUSH = 'delivery_manage.actual-push',
  DELIVERY_MANAGEMENT_TEST_PUSH = 'delivery_manage.test-push',
  ADMIN_MANAGE = 'admin.manage',
}

export const DEFAULT_PERMISSION = [Permission.OFFICIAL_ACCOUNT_READ];
